export async function generateCodeChallenge(codeVerifier: string): Promise<string> {
  const encode = await sha256(codeVerifier);
  return base64EncodeNative(hexToBytes(encode));
}

/**
 * https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#converting_a_digest_to_a_hex_string
 * @param message
 */
export async function sha256(message: string): Promise<string> {
  if (!window.crypto.subtle) {
    throw new Error('Crypto API is not supported in this environment.');
  }

  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
}

function hexToBytes(hex: string): Uint8Array {
  if (hex.length % 2 !== 0) throw new Error('Invalid hex string');
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.slice(i, i + 2), 16);
  }
  return bytes;
}

function base64EncodeNative(input: Uint8Array): string {
  let binary = '';
  input.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * Improved version of `encodeURIComponent` (RFC2396).
 * This also encodes `! * ' ( )`.
 */
export function encodeRFC3986(uri: string) {
  return uri.replace(/[!'()*]/g, (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase());
}
